export default function PartnershipModels() {
  return (
    <section id="partnership" className="py-20 sm:py-24 lg:py-28 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 sm:mb-20">
          <div className="inline-block mb-5 sm:mb-7">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Partnership Models
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-5 sm:mb-7 leading-tight px-4">
            貴社に合わせた柔軟な提携モデル
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto px-4">
            特定の形式に縛られることはありません。貴社の課題やプロジェクトの規模に合わせて、最適な連携の形を協議の上で設計いたします。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-10 mb-16 sm:mb-20">
          {/* モデル1 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-2">【伴走型】</h3>
              <p className="text-base sm:text-lg font-semibold text-white/90">ブランド構築・全行程同行プラン</p>
            </div>
            <div className="p-6 sm:p-8">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6">
                タレント 菊田あや子が同行し、チームが全行程を撮影・発信。ブランド化を目指すモデル。
              </p>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">タレント 菊田あや子の同行</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">全行程撮影</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">リアルタイムSNS発信</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">事前・事後の戦略的広報</p>
                </div>
              </div>
            </div>
          </div>

          {/* モデル2 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-2">【即戦力】</h3>
              <p className="text-base sm:text-lg font-semibold text-white/90">集客最大化・広報特化プラン</p>
            </div>
            <div className="p-6 sm:p-8">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6">
                催行決定を目指すための、タレント 菊田あや子とSNS活用特化モデル。
              </p>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">事前告知・集客支援</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">タレント 菊田あや子との直接アプローチ</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">SNS広告運用</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">LP最適化サポート</p>
                </div>
              </div>
            </div>
          </div>

          {/* モデル3 */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border-t-4 border-[#d4af37]">
            <div className="bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-2">【資産化】</h3>
              <p className="text-base sm:text-lg font-semibold text-white/90">次世代コンテンツ制作プラン</p>
            </div>
            <div className="p-6 sm:p-8">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6">
                次回の大型募集を見据え、既存ツアーを「売れる素材」に変えるモデル。
              </p>
              <div className="space-y-2 sm:space-y-3">
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">撮影</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">映像・写真素材の制作</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">パンフレット用素材提供</p>
                </div>
                <div className="flex items-start gap-2 sm:gap-3">
                  <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs sm:text-sm text-gray-600">WEB用コンテンツ制作</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 結びの文章 */}
        <div className="text-center mt-16 sm:mt-20">
          <p className="text-base sm:text-lg lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8] font-medium max-w-3xl mx-auto px-4">
            これら以外の組み合わせや、特定フェーズのみのサポートも対応いたします。貴社の業務フローに合わせた最適な座組みを提案させていただきます。
          </p>
        </div>
      </div>
    </section>
  );
}